module.exports = __webpack_public_path__ + "static/media/FotoClinica.76b23b28.jpg";